import { isEmpty } from "lodash";
import React, {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import _ from "lodash";
import SelectInput from "../SelectInput";

const CellSelectInput = forwardRef((props, ref) => {
  const {
    options = [],
    label,
    id,
    value,
    freeSolo = false,
    renderOption,
    onInputChange,
    getOptionLabel,
    isOptionEqualToValue,
    onChange = () => {},
  } = props;
  const [controlledValue, setControlledValue] = useState(null);
  const cellRef = useRef();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  let debouncedFocus = useCallback(
    _.debounce(() => cellRef.current.focus({ preventScroll: true }, 1)),
    []
  );
  useImperativeHandle(ref, () => {
    return { getValue: () => controlledValue, isCancelAfterEnd: () => false };
  });
  useEffect(() => {
    debouncedFocus();
    return () => {
      debouncedFocus.cancel();
    };
  }, [debouncedFocus]);
  useEffect(() => {
    if (!isEmpty(value)) setControlledValue(value);
  }, [value]);
  return (
    <div className="ag-grid-select-input">
      <SelectInput
        label={label}
        id={id}
        ref={cellRef}
        onChange={(e, newValue) => {
          onChange(newValue);
          setControlledValue(newValue?.label);
        }}
        isOptionEqualToValue={isOptionEqualToValue}
        getOptionLabel={getOptionLabel}
        value={controlledValue}
        freeSolo={freeSolo}
        renderOption={renderOption}
        onInputChange={onInputChange}
        options={options}
        fullWidth
        InputProps={{ style: { background: "white" } }}
      />
    </div>
  );
});

export default CellSelectInput;
